import { Device } from 'containers/BuilderPage/store/responsive/slice';
import { css, Styles, Theme } from 'wiloke-react-core';

export const container = ({ colors, fonts }: Theme) => css`
  debug: TopBar_container;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.light};
  border-bottom: 1px solid ${colors.gray3};
  height: 54px;
  padding: 12px;
  font-family: ${fonts.primary};
`;

export const iconWrap = ({ colors }: Theme) => css`
  debug: TopBar_iconWrap;
  background-color: ${colors.light};
  min-width: 36px;
  height: 36px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid ${colors.gray3};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const icon = css`
  debug: TopBar_icon;
  width: 36px;
  vertical-align: middle;
`;

export const divider = ({ colors }: Theme) => css`
  debug: TopBar_divider;
  width: 1px;
  height: 100%;
  background-color: ${colors.gray3};
`;

export const left = css`
  debug: TopBar_left;
  display: flex;
  flex-direction: row;
`;

export const right = css`
  debug: TopBar_right;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const itemFull = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const previewContainer = (responsive: Device) => ({ colors }: Theme): Styles => ({
  position: 'relative',
  transformOrigin: '50% 0',
  transition: 'all 0.2s',
  backgroundColor: colors.light,
  margin: `${responsive === 'desktop' ? '0px' : '20px'} auto`,
  height: `calc(100vh - 70px - ${responsive === 'desktop' ? '0px' : '40px'})`,
  width: responsive === 'mobile' ? '400px' : responsive === 'tablet' ? '767px' : responsive === 'tablet-h' ? '991px' : '100%',
  '> div': {
    height: '100%',
  },
});

export const modal = {
  body: ({ colors }: Theme) => css`
    max-width: 100%;
    height: calc(100% - 20px);
    width: calc(100% - 20px);
    margin: 0;
    background-color: ${colors.gray2};
  `,
  header: css`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
  `,
};
